import { Navigate, Route } from "react-router-dom";

// Monthly Rewards now lives as a tab inside /my-shelf. This keeps existing
// deep links / bookmarks pointing at the old /gold-rewards URL working.
export const routes = (
  <Route
    path="gold-rewards/*"
    element={<Navigate to="/my-shelf/gold-rewards" replace />}
  />
);
